import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth, initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

// On native Capacitor, use indexedDB persistence so onAuthStateChanged fires reliably
function createAuth() {
  if (typeof window !== "undefined" && Capacitor.isNativePlatform()) {
    return initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });
  }
  return getAuth(app);
}

export const storage = getStorage(app);
export const auth = createAuth();
export const functions = getFunctions(app, 'us-central1');
export const db = getFirestore(app);

